import type { ScaleLinear } from 'd3-scale';

export const AxisBottom = ({
  xScale,
  numberOfTicksTarget,
  y,
  textColor,
  lineColor,
}: {
  xScale: ScaleLinear<number, number>;
  numberOfTicksTarget: number;
  y: number;
  textColor: string;
  lineColor: string;
}) => {
  const range = xScale.range();

  const ticks = xScale
    .ticks(numberOfTicksTarget)
    .filter((value) => Number.isInteger(value))
    .map((value) => ({
      value,
      xOffset: xScale(value),
    }));

  return (
    <g transform={`translate(0,${y})`} fill={textColor}>
      {/* Main horizontal line */}
      <rect
        x={range[0]}
        y={0}
        width={range[1]! - range[0]!}
        height="16px"
        fill={lineColor}
        rx={2}
        ry={2}
      />

      {/* Ticks and labels */}
      {ticks.map(({ value, xOffset }) => (
        <g key={value} transform={`translate(${xOffset}, 0)`}>
          <text
            key={value}
            stroke="none"
            fill="inherit"
            style={{
              fontSize: '20px',
              textAnchor: 'middle',
              dominantBaseline: 'hanging',
              transform: 'translateY(30px)',
            }}
          >
            {value}
          </text>
        </g>
      ))}
    </g>
  );
};
